import {
  ADD_ASSET_SELECTION,
  INVALIDATE_ASSETS_SELECTION,
  REMOVE_ASSET_SELECTION,
  ADD_COLLECTION_SELECTION,
  REMOVE_COLLECTION_SELECTION,
  INVALIDATE_COLLECTIONS_SELECTION,
  ADD_COLLECTION_LIST_SELECTION,
  REMOVE_COLLECTION_LIST_SELECTION,
  INVALIDATE_COLLECTION_LISTS_SELECTION,
  ADD_GROUP_SELECTION,
  INVALIDATE_GROUPS_SELECTION,
  REMOVE_GROUP_SELECTION,
  UPLOADING_FILE_REQUEST,
  UPLOADING_FILE_SUCCEDDED,
  UPLOADING_FILE_FAILED,
  UPLOADING_FILE_PROGRESS,
  CREATING_ASSET_REQUEST,
  CREATING_ASSET_SUCCEDDED,
  CREATING_ASSET_FAILED,
  ADD_ASSET_URL,
  ADD_ASSET_URL_SUCCEDDED,
  ADD_ASSET_URL_FAILED,
  ADD_COLLECTION_SECTION_SELECTION,
  REMOVE_COLLECTION_SECTION_SELECTION,
  INVALIDATE_COLLECTION_SECTION_SELECTION,
  ADD_CONTACT_SELECTION,
  REMOVE_CONTACT_SELECTION,
  INVALIDATE_CONTACT_SELECTION,
  ADD_USER_SELECTION,
  REMOVE_USER_SELECTION,
  INVALIDATE_USER_SELECTION,
  WS_ASSET_PROCESSED,
  ADD_STREAM_SELECTION,
  REMOVE_STREAM_SELECTION,
  INVALIDATE_STREAMS_SELECTION,
  MOVE_ENTITY_IN_SELECTION,
  SELECT_ASSET_PAGE,
  REMOVE_ASSET_PAGE,
  INVALIDATE_SELECTED_ASSET_PAGES,
  REARRANGE_ASSET_PAGES
} from "../actions/actionTypes.jsx";

import _ from "lodash";

const initialState = {
  assets: [],
  groups: [],
  collections: [],
  collectionSections: [],
  contacts: [],
  users: [],
  customSlides: {
    item: {}
  },
  collectionLists: [],
  streams: [],
  selectedPages: []
};

export function selectionReducer(state = initialState, action) {
  switch (action.type) {
    case ADD_ASSET_URL:
      var url = {
        type: "url",
        url: action.payload.url
      };

      return Object.assign({}, state, {
        ...state,
        assets: [...state.assets, url]
      });
    case ADD_ASSET_URL_SUCCEDDED:
      var assets = state.assets.map(item => {
        if (item.type == "url" && item.url == action.payload.url) {
          return {
            type: "asset",
            url: action.payload.url,
            asset: action.payload.asset
          };
        } else {
          return item;
        }
      });

      return Object.assign({}, state, {
        ...state,
        assets: assets
      });

    case ADD_ASSET_URL_FAILED:
      var assets = state.assets.filter(item => {
        if (item.type == "url" && item.url == action.payload.url) {
          return false;
        }

        return true;
      });

      return Object.assign({}, state, {
        ...state,
        assets: assets
      });

    case ADD_ASSET_SELECTION:
      var asset = action.payload.asset;
      var index = state.assets.findIndex(function(element) {
        return element.type == "asset" && element.asset.id == asset.id;
      });

      if (index == -1) {
        return Object.assign({}, state, {
          ...state,
          assets: [
            ...state.assets,
            {
              type: "asset",
              asset: asset
            }
          ]
        });
      } else {
        return state;
      }

    case REMOVE_ASSET_SELECTION:
        var assets = state.assets.filter(item => {

        if (item.type == "asset") {
          var id = _.get(action, 'payload.id') || _.get(action, 'payload.asset.id');
          return _.get(item, 'asset.id') != id;
        }
        else if (item.entityType == "asset") {
          var id = _.get(action, 'payload.id') || _.get(action, 'payload.asset.id');
          return _.get(item, 'id') != id;
        }

        if (
          item.type == "file" &&
          _.get(item, 'file.preview') == _.get(action, 'payload.file.preview')
        ) {
          return false;
        }

        return true;
      });

      return Object.assign({}, state, {
        ...state,
        assets: assets
      });

    case INVALIDATE_ASSETS_SELECTION:
      return Object.assign({}, state, {
        ...state,
        assets: []
      });

      
      case UPLOADING_FILE_REQUEST:
  return {
    ...state,
    assets: [
      ...state.assets,
      {
        type: action.payload.file.isDirectory ? "folder" : "file",
        uploading: true,
        file: { ...action.payload.file } // Ensure a shallow copy of the file object
      }
    ]
  };

case UPLOADING_FILE_FAILED:
  return {
    ...state,
    assets: state.assets.map(item => {
      if (item.type === "file" && item.file.preview === action.payload.file.preview) {
        return {
          ...item,
          uploading: false,
          error: action.payload.error, // Make sure error is handled correctly
          file: { ...item.file } // Ensure a shallow copy of the file object
        };
      }
      return item;
    })
  };

case UPLOADING_FILE_PROGRESS:
  return {
    ...state,
    assets: state.assets.map(item => {
      if (item.type === "file" && item.file.preview === action.payload.file.preview) {
        return {
          ...item,
          uploading: true,
          progress: action.payload.progress,
          file: { ...item.file } // Ensure a shallow copy of the file object
        };
      }
      return item;
    })
  };

    case CREATING_ASSET_REQUEST:
      var assets = state.assets.map(item => {
        if (
          item.type == "file" &&
          item.file.preview == action.payload.file.preview
        ) {
          return {
            ...item,
            uploading: false,
            creating: true
          };
        } else {
          return item;
        }
      });

      return Object.assign({}, state, {
        ...state,
        assets: assets
      });

    case CREATING_ASSET_SUCCEDDED:
      var assets = state.assets.map(item => {
        if (item.type == "file" && (item.file.preview != null ? item.file.preview == action.payload.file.preview : item.file.id == action.payload.file.id)) {
            return {
              type: "asset",
              asset: action.payload.asset
            };
        } else {
          return item;
        }
      });

      return Object.assign({}, state, {
        ...state,
        assets: assets
      });

    case CREATING_ASSET_FAILED:
      var assets = state.assets.map(item => {
        if (
          item.type == "file" &&
          item.file.preview == action.payload.file.preview
        ) {
          return {
            ...item,
            uploading: false,
            error: action.payload.error
          };
        } else {
          return item;
        }
      });

      return Object.assign({}, state, {
        ...state,
        assets: assets
      });

    case ADD_GROUP_SELECTION:
      var group = action.payload;
      var index = state.groups.findIndex(function(element) {
        return element.id == group.id;
      });

      if (index == -1) {
        return Object.assign({}, state, {
          ...state,
          groups: [...state.groups, group]
        });
      } else {
        return state;
      }

    case REMOVE_GROUP_SELECTION:
      var groups = state.groups.filter(item => {
        return item.id != action.payload.id;
      });

      return Object.assign({}, state, {
        ...state,
        groups: groups
      });

    case INVALIDATE_GROUPS_SELECTION:
      return Object.assign({}, state, {
        ...state,
        groups: []
      });

    case ADD_COLLECTION_SECTION_SELECTION:
      var section = action.payload.section;
      var collection = action.payload.collection;
      var index = state.collectionSections.findIndex(function(element) {
        return element.id == section.id;
      });

      if (index == -1) {
        return Object.assign({}, state, {
          ...state,
          collectionSections: [
            ...state.collectionSections,
            {
              id: section.id,
              collection: collection.id,
              item: section
            }
          ]
        });
      } else {
        return state;
      }

    case REMOVE_COLLECTION_SECTION_SELECTION:
      var section = action.payload.section;
      var sections = state.collectionSections.filter(item => {
        return item.id != section.id;
      });

      return Object.assign({}, state, {
        ...state,
        collectionSections: sections
      });

    case INVALIDATE_COLLECTION_SECTION_SELECTION:
      return Object.assign({}, state, {
        ...state,
        collectionSections: []
      });

    case ADD_COLLECTION_SELECTION:
      var collection = action.payload;
      var index = state.collections.findIndex(function(element) {
        return element.id == collection.id;
      });

      if (index == -1) {
        return Object.assign({}, state, {
          ...state,
          collections: [...state.collections, collection]
        });
      } else {
        return state;
      }

    case REMOVE_COLLECTION_SELECTION:
      var collections = state.collections.filter(item => {
        return item.id != action.payload.id;
      });

      return Object.assign({}, state, {
        ...state,
        collections: collections
      });

    case INVALIDATE_COLLECTIONS_SELECTION:
      return Object.assign({}, state, {
        ...state,
        collections: []
      });
    
    case ADD_COLLECTION_LIST_SELECTION:
      var collectionList = action.payload;
      var index = state.collectionLists.findIndex(function (element) {
        return element.id == collectionList.id;
      });

      if (index == -1) {
        return Object.assign({}, state, {
          ...state,
          collectionLists: [...state.collectionLists, collectionList]
        });
      } else {
        return state;
      }

    case REMOVE_COLLECTION_LIST_SELECTION:
      var collectionLists = state.collectionLists.filter(item => {
        return item.id != action.payload.id;
      });

      return Object.assign({}, state, {
        ...state,
        collectionLists: collectionLists
      });

    case INVALIDATE_COLLECTION_LISTS_SELECTION:
      return Object.assign({}, state, {
        ...state,
        collectionLists: []
      });

    case ADD_CONTACT_SELECTION:
      var contact = action.payload;
      var index = state.contacts.findIndex(function(element) {
        return element.id == contact.id;
      });
      var newContacts = [..._.get(state,"contacts",[]),contact];
      newContacts = _.sortBy(newContacts, obj => _.get(obj,"firstName").toLowerCase());

      if (index == -1) {
        return Object.assign({}, state, {
          ...state,
          contacts: newContacts
        });
      } else {
        return state;
      }

    case REMOVE_CONTACT_SELECTION:
      var contacts = state.contacts.filter(item => {
        return item.id != action.payload.id;
      });

      return Object.assign({}, state, {
        ...state,
        contacts: contacts
      });

    case INVALIDATE_CONTACT_SELECTION:
      return Object.assign({}, state, {
        ...state,
        contacts: []
      });

    case WS_ASSET_PROCESSED:
      var assets = state.assets.map(item => {
        if (item.type == "asset" && item.asset.id == action.payload.id) {
          return {
            ...item,
            asset: action.payload
          };
        } else {
          return item;
        }
      });

      return Object.assign({}, state, {
        ...state,
        assets: assets
      });


    case ADD_USER_SELECTION:
      var user = action.payload;

      var index = state.users.findIndex(element => {
        return element.id == user.id;
      });

      if (index == -1) {
        return Object.assign({}, state, {
          ...state,
          users: [...state.users, user]
        });
      } else {
        return state;
      }

    case REMOVE_USER_SELECTION:
      var users = state.users.filter(item => {
        return item.id != action.payload.id;
      });

      return Object.assign({}, state, {
        ...state,
        users: users
      });

    case INVALIDATE_USER_SELECTION:
      return Object.assign({}, state, {
        ...state,
        users: []
      });

    case ADD_STREAM_SELECTION:
      var stream = action.payload;
      var index = state.streams.findIndex((element) => {
        return element.type == "stream" && element.stream.id == stream.id;
      });
  
      if (index == -1) {
        return Object.assign({}, state, {
          ...state,
          streams: [
            ...state.streams,
            {
              stream: stream
            }
          ]
        });
      } else {
        return state;
    }
  
    case REMOVE_STREAM_SELECTION:
      var streams = state.streams.filter(item => {
          var id = action.payload.id;
          return item.stream.id != id;
      });
      
      return Object.assign({}, state, {
        ...state,
        streams: streams
      });
      
    case INVALIDATE_STREAMS_SELECTION:
      return Object.assign({}, state, {
        ...state,
        streams: []
      }); 

    case MOVE_ENTITY_IN_SELECTION:  
      var {entityType, fromIndex, toIndex } = action.payload;

      var entities = state[entityType] || [];
      var entity = entities[fromIndex];

      if(!entity) {
        return state;
      }

      var entityIndex = entities.findIndex(item => {
        var type = item.stream && item.stream.entityType || item.asset && item.asset.entityType || "collection";
        if(type == "collection"){
          return item.id == entity.id;
        } else {
          return item[type].id == entity[type].id;
        }
      })

      var sourceEntity = entities[entityIndex];
      entities.splice(entityIndex, 1);
      entities.splice(toIndex, 0, sourceEntity);


      return Object.assign({}, state, {
        ...state,
        [entityType]: entities 
      })  

      case SELECT_ASSET_PAGE: 
      var {page} = action.payload;
      var {selectedAsset} = action.payload;

      page = {...page, asset : {
        id : selectedAsset.id,
        name : selectedAsset.name
      }};

      return{
        ...state,
        selectedPages: [...state.selectedPages, page]
      }
      
      case REMOVE_ASSET_PAGE:
        var { assetId } = action.payload;
        var { page } = action.payload;
        
        const filteredPages = state.selectedPages.filter(selectedPage => selectedPage.background.id != page.background.id);

        return{
          ...state,
          selectedPages : filteredPages
        }

        case INVALIDATE_SELECTED_ASSET_PAGES:

        return{
          ...state,
          selectedPages: []
        }

        case REARRANGE_ASSET_PAGES:
          var { pages } = action.payload;

          return{
            ...state,
            selectedPages: pages
          }


    default:
      return state;
  }
}
